/** @type {import('tailwindcss').Config} */
// eslint-disable-next-line @typescript-eslint/no-require-imports, no-undef
const colors = require("tailwindcss/colors");

// eslint-disable-next-line no-undef
module.exports = {
  content: ["./src/**/*.{html,js,jsx,ts,tsx}"],
  darkMode: "class",
  important: true,
  theme: {
    colors: {
      purple: colors.purple,
      teal: colors.teal,
      cyan: colors.cyan,
      amber: colors.amber,
      slate: colors.slate,
      blue: colors.blue,
      durableTeal: {
        100: "hsl(182, 100%, 9%)",
        200: "hsl(181, 92%, 18%)",
        300: "hsl(164, 77%, 62%)",
        400: "hsl(164, 90%, 80%)",
        500: "hsl(164, 92%, 94%)"
      },
      durableTealDark: {
        100: "hsl(190, 100%, 5%)",
        200: "hsl(183, 95%, 11%)",
        300: "hsl(174, 95%, 36%)",
        400: "hsl(174, 95%, 73%)",
        500: "hsl(174, 100%, 93%)"
      },
      complementOrange: {
        100: "hsl(14, 80%, 10%)",
        200: "hsl(14, 80%, 30%)",
        300: "hsl(14, 80%, 60%)",
        400: "hsl(14, 100%, 70%)",
        500: "hsl(14, 100%, 88%)"
      },
      blueprintBlue: {
        100: "hsl(213, 100%, 22%)",
        200: "hsl(204, 99%, 29%)",
        300: "hsl(201, 100%, 35%)",
        400: "hsl(199, 97%, 41%)",
        500: "hsl(188, 91%, 46%)"
      },
      coolGrey: {
        100: "hsl(209, 18%, 5%)",
        200: "hsl(209, 18%, 12%)",
        300: "hsl(209, 16%, 20%)",
        400: "hsl(209, 15%, 25%)",
        500: "hsl(208, 12%, 43%)",
        600: "hsl(208, 12%, 58%)",
        700: "hsl(210, 16%, 76%)",
        800: "hsl(210, 16%, 79%)",
        900: "hsl(208, 12%, 88%)",
        1000: "hsl(0, 0%, 100%)"
      },
      error: {
        100: "hsl(356, 100%, 5%)",
        200: "hsl(356, 100%, 29%)",
        300: "hsl(356, 75%, 42%)",
        400: "hsl(356, 90%, 84%)",
        500: "hsl(356, 100%, 92%)"
      },
      warning: {
        100: "hsl(44, 66%, 5%)",
        200: "hsl(44, 76%, 29%)",
        300: "hsl(44, 87%, 42%)",
        400: "hsl(44, 90%, 84%)",
        500: "hsl(44, 100%, 92%)"
      },
      success: {
        100: "hsl(155, 59%, 5%)",
        200: "hsl(149, 57%, 29%)",
        300: "hsl(145, 54%, 42%)",
        400: "hsl(143, 69%, 84%)",
        500: "hsl(142, 81%, 92%)"
      },
      invisible: "hsl(0, 0%, 100%, 0)"
    },
    fontFamily: {
      sans: ["Ubuntu", "Roboto"],
      header: ["Ubuntu", "Roboto"],
      mono: ["Ubuntu Mono"]
    },
    extend: {}
  },
  plugins: [],
  corePlugins: {
    preflight: false
  },
  // All bg and text classes are safe-listed, since CSS classes may be
  // constructed dynamically in react. This prevents tailwind pruning these
  // class definitions if they aren't used directly within a HTML react
  // component.
  safelist: [
    {
      pattern: /(bg|text)-.*/
    }
  ]
};
